var map = {
	"./archive.svg": 370,
	"./audio.svg": 371,
	"./doc.svg": 372,
	"./excel.svg": 373,
	"./folder.svg": 374,
	"./generic.svg": 375,
	"./image.svg": 376,
	"./json.svg": 377,
	"./layered.svg": 378,
	"./pdf.svg": 379,
	"./picture.svg": 380,
	"./presentation.svg": 381,
	"./video.svg": 382,
	"./xml.svg": 383
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 676;